import { render, staticRenderFns } from "./AtlasLogo.vue?vue&type=template&id=61237e36&"
import script from "./AtlasLogo.vue?vue&type=script&lang=js&"
export * from "./AtlasLogo.vue?vue&type=script&lang=js&"
import style0 from "./AtlasLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports